import { useEffect, useState } from "react";
import {
  Box,
  Chip,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  ListItem,
  Pagination,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { Clear, OpenInNew, Search } from "@mui/icons-material";
import api from "../../../../../services/api";
import ModalDetails from "./modalDetails";
import useStyles from "./styles";
import DatagridComponent from "../../../../../components/datagridComponent";
import { minHeight } from "@mui/system";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import customParseFormat from "dayjs/plugin/customParseFormat";

const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);

const timeZone = "America/Sao_Paulo";

//dayjs(cobranca?.invoice_date_due).format("DD-MM-YYYY") || "-",
export default function Auditoria(params) {
  const { searchItem, setSearchItem, filterData } = params;
  const theme = useTheme();
  const styles = useStyles(theme);
  const [rows, setRows] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  // const [filteredRows, setFilteredRows] = useState({});
  const [initialLoad, setInitialLoad] = useState(true);
  const [openDetalhes, setOpenDetalhes] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Função para receber dados do banco
  async function handleGetLogs() {
    try {
      setInitialLoad(true);
      const response = await api.post("/interno/administracao/logs", {
        initialDate: filterData?.initialDate,
        finalDate: filterData?.finalDate,
      });

      setRows(response?.data);
    } catch (error) {
    } finally {
      setInitialLoad(false);
    }
  }

  useEffect(() => {
    // Ao carregar a página chama api para receber os logs
    handleGetLogs();

    // Define state com a largura da tela
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    // Adiciona um listener ao evento de redimensionar a tela
    window.addEventListener("resize", handleResize);
    // O evento chama a função que define o valor do state
  }, [filterData]);

  // Filtra os dados a serem seguidos de acordo com a busca

  const filteredRows = rows?.filter((row, index) => {
    row.numero = index;

    // Obter nome do usuário para busca
    let nome = "";
    if (row?.user?.perfil && row.user.perfil.length > 0) {
      nome = `${row.user.perfil[0]?.nome?.toLowerCase() || ""} ${
        row.user.perfil[0]?.sobrenome?.toLowerCase() || ""
      }`;
    } else if (row?.user?.perfilCliente && row.user.perfilCliente.length > 0) {
      nome = `${row.user.perfilCliente[0]?.nome?.toLowerCase() || ""} ${
        row.user.perfilCliente[0]?.sobrenome?.toLowerCase() || ""
      }`;
    } else if (row?.user?.nome && row?.user?.sobrenome) {
      nome = `${row.user.nome?.toLowerCase()} ${row.user.sobrenome?.toLowerCase()}`;
    } else {
      nome = row?.user?.login?.toLowerCase() || "";
    }

    return (
      row?.action?.toLowerCase()?.includes(searchItem?.toLowerCase()) ||
      row?.session?.enderecoIp
        ?.toLowerCase()
        ?.includes(searchItem?.toLowerCase()) ||
      row?.resource?.toLowerCase()?.includes(searchItem?.toLowerCase()) ||
      dayjs(row?.time)
        ?.format("DD/MM/YYYY HH:mm:ss")
        ?.toLowerCase()
        ?.includes(searchItem?.toLowerCase()) ||
      nome?.includes(searchItem?.toLowerCase())
    );
  });

  //views a serem renderizados nos referentes renderCell
  const timeCellView = (params) => {
    const formattedDate = dayjs(params?.row?.time)
      .tz(timeZone)
      .format("DD/MM/YYYY HH:mm:ss");

    const [date, time] = formattedDate.split(" ");

    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          gap: 1,
        }}
      >
        <Typography sx={styles.typographCellView}>{date}</Typography>
        <Typography sx={styles.typographCellView}>{time}</Typography>
      </Box>
    );
  };

  const userCellView = (params) => {
    // Verifica se é um usuário interno (com perfil) ou cliente
    const user = params?.row?.user;
    let nomeCompleto = "";

    if (user?.perfil && user.perfil.length > 0) {
      // Usuário interno
      nomeCompleto = `${user.perfil[0]?.nome || ""} ${
        user.perfil[0]?.sobrenome || ""
      }`.trim();
    } else if (user?.perfilCliente && user.perfilCliente.length > 0) {
      // Usuário cliente
      nomeCompleto = `${user.perfilCliente[0]?.nome || ""} ${
        user.perfilCliente[0]?.sobrenome || ""
      }`.trim();
    } else if (user?.nome && user?.sobrenome) {
      // Estrutura alternativa
      nomeCompleto = `${user.nome} ${user.sobrenome}`;
    } else {
      nomeCompleto = user?.login || "Usuário não identificado";
    }

    return (
      <Box sx={styles.boxCellView}>
        <Typography sx={styles.typographCellView}>{nomeCompleto}</Typography>
      </Box>
    );
  };

  const ipCellView = (params) => {
    return (
      <Box sx={styles.boxCellView}>
        <Typography sx={styles.typographCellView}>
          {params?.row?.session?.enderecoIp}
        </Typography>
      </Box>
    );
  };

  const tableCellView = (params) => {
    return (
      <Box sx={styles.boxCellView}>
        <Typography sx={styles.typographCellView}>
          {params?.row?.resource}
        </Typography>
      </Box>
    );
  };

  const actionCellView = (params) => {
    return (
      <Chip
        sx={{
          height: "18px",
          width: "100px",

          bgcolor:
            params?.row?.action === "Criação"
              ? "success.main"
              : params?.row?.action === "Edição"
              ? "secondary.main"
              : "error.main",
          color: theme.palette.white.main,
        }}
        label={params?.row?.action}
      />
    );
  };

  const detailCellView = (params) => {
    return (
      <Tooltip title="Detalhes da ação">
        <IconButton
          onClick={(event) => {
            event.preventDefault();
            //setAnchorEl(event.currentTarget);
            setSelectedRow(params.row);
            setOpenDetalhes(!openDetalhes);
          }}
          id="basic-button"
          sx={{
            paddingY: 0,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <OpenInNew mode="view" params={params} />
        </IconButton>
      </Tooltip>
    );
  };

  // Definição de colunas
  const columns = [
    {
      editable: false,
      field: "id",
      headerName: "ID",
      hide: true,
    },
    {
      field: "time",
      headerName: "Hora",
      flex: 1,
      type: "dataTime",
      renderCell: timeCellView,
    },
    {
      field: "user",
      headerName: "Usuário",
      flex: 1,
      renderCell: userCellView,
    },
    {
      field: "ip",
      headerName: "IP",
      flex: 1,
      renderCell: ipCellView,
    },
    {
      field: "table",
      headerName: "Recurso",
      flex: 0.8,
      renderCell: tableCellView,
    },
    {
      field: "action",
      headerName: "Ação",
      flex: 0.6,
      renderCell: actionCellView,
    },
    {
      field: "detail",
      headerName: "Detalhes",
      //flex: 1,
      width: 90,
      renderCell: detailCellView,
      sortable: false,
    },
  ];

  // Variáveis para o carregamento mobile
  const PER_PAGE = 10;
  const count = Math.ceil(filteredRows.length / PER_PAGE);
  const _DATA = usePagination(filteredRows, PER_PAGE);
  const [page, setPage] = useState(1);

  // Pagination para o mobile
  function usePagination(data, itemsPerPage) {
    const [currentPage, setCurrentPage] = useState(1);
    const maxPage = Math.ceil(data.length / itemsPerPage);

    function currentData() {
      const begin = (currentPage - 1) * itemsPerPage;
      const end = begin + itemsPerPage;
      return data.slice(begin, end);
    }

    function next() {
      setCurrentPage((currentPage) => Math.min(currentPage + 1, maxPage));
    }

    function prev() {
      setCurrentPage((currentPage) => Math.max(currentPage - 1, 1));
    }

    function jump(page) {
      const pageNumber = Math.max(1, page);
      setCurrentPage((currentPage) => Math.min(pageNumber, maxPage));
    }

    return { next, prev, jump, currentData, currentPage, maxPage };
  }

  // Fução para alterar a página no pagination do mobile
  const handleChangePage = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <Box sx={styles.boxDataGrid}>
      {windowWidth <= 760 ? (
        // Exibição Mobile
        <Grid container spacing={1}>
          <Divider />
          {Array.isArray(filteredRows) &&
            _DATA.currentData().map((row, index) => (
              <Grid item xs={12} key={index}>
                <ListItem sx={styles.mobile.listItem}>
                  <Box sx={styles.mobile.content}>
                    <Box sx={styles.mobile.contentRow}>
                      <Box>
                        <Typography
                          sx={styles.mobile.typography}
                          variant="caption"
                        >
                          Hora:{" "}
                        </Typography>
                        <Typography variant="caption">
                          {dayjs(row?.time)
                            .tz(timeZone)
                            .format("DD/MM/YYYY HH:mm:ss")}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography
                          sx={styles.mobile.typography}
                          variant="caption"
                        >
                          Usuário:{" "}
                        </Typography>
                        <Typography variant="caption">
                          {(() => {
                            const user = row?.user;
                            if (user?.perfil && user?.perfil?.length > 0) {
                              return `${user?.perfil[0]?.nome || ""} ${
                                user?.perfil[0]?.sobrenome || ""
                              }`.trim();
                            } else if (
                              user?.perfilCliente &&
                              user?.perfilCliente?.length > 0
                            ) {
                              return `${user?.perfilCliente[0]?.nome || ""} ${
                                user?.perfilCliente[0]?.sobrenome || ""
                              }`.trim();
                            } else if (user?.nome && user?.sobrenome) {
                              return `${user?.nome} ${user?.sobrenome}`;
                            } else {
                              return user?.login || "Usuário não identificado";
                            }
                          })()}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={styles.mobile.contentRow}>
                      <Box>
                        <Typography
                          sx={styles.mobile.typography}
                          variant="caption"
                        >
                          IP:{" "}
                        </Typography>
                        <Typography variant="caption">
                          {row?.session?.enderecoIp}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography
                          sx={styles.mobile.typography}
                          variant="caption"
                        >
                          Recurso:{" "}
                        </Typography>
                        <Typography variant="caption">
                          {row?.resource}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography
                        sx={styles.mobile.typography}
                        variant="caption"
                      >
                        Ação:{" "}
                      </Typography>
                      <Typography variant="caption">{row?.action}</Typography>
                    </Box>
                  </Box>
                  <IconButton
                    onClick={(event) => {
                      event.preventDefault();
                      //setAnchorEl(event.currentTarget);
                      setSelectedRow(row);
                      setOpenDetalhes(!openDetalhes);
                    }}
                    id="basic-button"
                  >
                    <OpenInNew mode="view" />
                  </IconButton>
                </ListItem>
                <Divider />
              </Grid>
            ))}
          <Grid item xs={12}>
            <Stack spacing={2} flex={1} alignItems={"center"}>
              <Pagination
                count={count}
                page={page}
                onChange={handleChangePage}
              />
            </Stack>
          </Grid>
        </Grid>
      ) : (
        // Exibição Desk//

        <Box
          sx={{
            display: "flex",
            width: "100%",
            ...(filteredRows?.length > 23 && {
              height: "calc(100vh - 174px)",
            }),
            overflow: "hidden",
          }}
        >
          <DatagridComponent
            rows={filteredRows}
            columns={columns}
            loading={initialLoad}
            setSelectedRow={setSelectedRow} // Para capturar a linha selecionada
            isPagination={true} // Habilita paginação
          />
        </Box>
      )}
      <ModalDetails
        openDetalhes={openDetalhes}
        setOpenDetalhes={setOpenDetalhes}
        selectedRow={selectedRow}
      />
    </Box>
  );
}
